<template>
    <div class="dashboard-layout">
        <navigation-bar />
        <div class="flex --align">
            <div class="sidebar">
                <side-bar />
            </div>
            <!-- CONTENT OF THE PAGE ACCORDING TO THE ROUTE -->
            <div class="view">
                <router-view :key="$route.fullPath" />
            </div>

            <!-- CONFIRMATION DIALOG IN CASE OF ANY UPDATE -->
            <confirmation />
        </div>
    </div>
</template>

<script>
import navigationBar from './components/navigation-bar.vue';
import sideBar from "./components/side-bar.vue";
import confirmationDialog from "../../views/MainDashboard/Common/confirmation-dialog.vue";

export default {
    name : 'dashboardLayout',

    components : {
        'navigation-bar' : navigationBar,
        'side-bar' : sideBar,
        'confirmation' : confirmationDialog
    }
}
</script>

<style scoped lang="scss">

.dashboard-layout {
  font-family: "Roboto";
  background: #E5E5E5;
  height: 100%;
  width: 100%;
}

.sidebar {
    position: sticky !important;
    top: 100px;
}

.dashboard-layout > .flex {
    justify-content: flex-start;
    align-items: flex-start;
}

.view {
    width: 100%;
    margin-bottom: 10px;
}

</style>